<template>
    <label>
        <input type="checkbox" v-model="isChecked" :checked="checked" />
        <span></span>
    </label>
</template>

<script>
    export default {
        name: "OnOff",
        props: {
            id: String,
            checked: Boolean
        },
        data: function() {
            return {
                isChecked: this.checked || false
            };
        },
        watch: {
            isChecked: function(newValue) {
                this.$emit("switch", this.id, newValue);
            }
        }
    }
</script>

<style scoped>
    label {
        position: relative;
        display: block;
        height: 100%;
        cursor: pointer;
        margin: 0;
    }
    input {
        display:none;
    }
    span {
        position: absolute;
        cursor: pointer;
        top: calc(50% - 10px);
        left: 0;
        right: 0;
        bottom: calc(50% - 10px);
        width: 34px;
        background-color: #ccc;
        -webkit-transition: .2s;
        -moz-transition: .2s;
        transition: .2s;
        -webkit-border-radius: 10px;
        -moz-border-radius: 10px;
        border-radius: 10px;
    }
    span:before {
        position: absolute;
        content: "";
        height: 14px;
        width: 14px;
        left: 3px;
        bottom: 3px;
        background-color: white;
        -webkit-transition: .2s;
        -moz-transition: .2s;
        transition: .2s;
        -webkit-border-radius: 10px;
        -moz-border-radius: 10px;
        border-radius: 10px;
    }

    input:checked + span {
        background-color: #2196F3;
    }

    input:focus + span {
        box-shadow: 0 0 1px #2196F3;
    }

    input:checked + span:before {
        -webkit-transform: translateX(14px);
        -moz-transform: translateX(14px);
        -ms-transform: translateX(14px);
        transform: translateX(14px);
    }
</style>
